import {
    SAVE_CURRENT_DB_CAPACITY,
    GET_ALL_SCHEDULED_SETTINGS
} from '../../actions/types';

const INITIAL_STATE = {
    capacity: 0,
    scheduledSettings: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SAVE_CURRENT_DB_CAPACITY:
            return {
                ...state,
                capacity: action.payload.capacity
            };
        case GET_ALL_SCHEDULED_SETTINGS:
            return {
                ...state,
                scheduledSettings: action.payload
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/systemControl/DatabaseReducer.js